<template>
  <div :class="classNames.navigation" :style="cssVars">
    <div
      v-ripple
      @click.prevent="$emit('prev')"
      :class="classNames.navItemPrev"
    >
      <v-icon :color="iconColor" :size="iconSize"> fa-angle-left </v-icon>
    </div>

    <div
      v-ripple
      @click.prevent="$emit('next')"
      :class="classNames.navItemNext"
    >
      <v-icon :color="iconColor" :size="iconSize"> fa-angle-right </v-icon>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dark: {
      type: Boolean,
      default: false,
    },
    disabledPrev: {
      type: Boolean,
      default: false,
    },
    disabledNext: {
      type: Boolean,
      default: false,
    },
    positionY: {
      type: Number,
      default: 50,
    },
    inside: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    classNames() {
      const classNames = {
        navigation: [
          "cursor-pointer carousel-widget-nav d-flex justify-space-between",
          this.inside && "carousel-widget-nav--inside",
        ],
        navItemPrev: [
          "cursor-pointer carousel-widget-nav-item-prev",
          !this.dark ? "transparent" : "white",
          this.disabledPrev && "carousel-widget-nav-item-disabled",
        ],
        navItemNext: [
          "carousel-widget-nav-item-next",
          !this.dark ? "transparent" : "white",
          this.disabledNext && "carousel-widget-nav-item-disabled",
        ],
      };
      return classNames;
    },

    iconSize() {
      return this.mobile ? 30 : 26;
    },
    iconColor() {
      return !this.dark ? "white" : "primary";
    },
    cssVars() {
      const buttonSize = this.mobile ? 32 : 40;

      return {
        "--button-size": `${buttonSize}px`,
        "--icon-size": `${this.iconSize}px`,
        "--position-y": `${this.positionY}%`,
      };
    },
  },
};
</script>

<style lang="scss">
.carousel-widget-nav {
  height: 0;
  position: absolute;
  left: calc(0px - var(--button-size) - 16px + var(--gap));
  right: calc(0px - var(--button-size) - 16px + var(--gap));
  top: calc(var(--position-y) - var(--button-size) / 2);

  &-item-prev,
  &-item-next {
    align-items: center;
    border-radius: 50%;
    cursor: pointer !important;
    display: flex;
    height: var(--button-size);
    justify-content: center;
    transition: all 0.1s linear;
    width: var(--button-size);
  }

  &-item-disabled {
    filter: grayscale(1);
    opacity: 0.8;
  }

  &-item-prev {
    padding-right: 2px;
    text-shadow: 1px 1px rgba(0, 0, 0, 1);
  }

  &-item-next {
    padding-left: 2px;
    text-shadow: -1px 1px rgba(0, 0, 0, 1);
  }
}

.carousel-widget-nav--inside {
  left: calc(var(--gap) + 8px);
  right: calc(var(--gap) + 8px);
}

@media screen and (max-width: 959.9px) {
  .carousel-widget-nav {
    right: calc(var(--gap) + 12px);
    left: calc(var(--gap) + 12px);
  }
}
</style>
